import { createFileRoute, redirect } from "@tanstack/react-router";
import { opsHead } from "~/head";

export const Route = createFileRoute("/__auth/admin")({
  head: () => opsHead("Admin"),
  beforeLoad({ location }) {
    const to = location.pathname.slice(10) || "/";
    throw redirect({
      to,
      search: location.search,
      hash: location.hash,
    });
  },
});
